import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Row, Col, ListGroup, Card } from 'react-bootstrap';
import { useGetNoteDetailsQuery } from '../slices/notesApiSlice';
import Loader from '../components/Loader';
import Message from '../components/Message';
import Meta from '../components/Meta';
import NoteCarousel from '../components/NoteCarousel';

const NoteScreen = () => {
  const { id: noteId } = useParams();
  const { data: note, isLoading, error } = useGetNoteDetailsQuery(noteId);

  const renderNoteDetails = () => (
    <>
      <Meta title={note.date} description={note.status} />
      <Row>
        <Col md={6}>
          {/* Display note images using NoteCarousel */}
          {note.images && note.images.length > 0 ? (
            <NoteCarousel images={note.images} />
          ) : (
            <Message variant="info">No images available for this note</Message>
          )}
        </Col>
        <Col md={3}>
          <ListGroup variant="flush">
            <ListGroup.Item>
              <h3>{note.accountName}</h3>
            </ListGroup.Item>
            <ListGroup.Item>Details: {note.details}</ListGroup.Item>
            <ListGroup.Item>Amount: {note.number}</ListGroup.Item>
            <ListGroup.Item>
              Details: {note.details}
            </ListGroup.Item>
            <ListGroup.Item>User:{note.username}</ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={3}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <Row>
                  <Col>Amount:</Col>
                  <Col>
                    <strong>{note.number}</strong>
                  </Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>User:</Col>
                  <Col>
                    {note.username}
                  </Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
          <div className="note-images mt-3">
                    <h6>Images:</h6>
                    <div className="image-thumbnails">
                      {note.images?.map((image, index) => (
                        <img
                          key={index}
                          src={image}
                          alt={` ${index + 1}`}
                          className="thumbnail-img"
                          style={{
                            width: '50px',
                            height: '50px',
                            marginRight: '5px',
                            borderRadius: '5px',
                          }}
                        />
                      ))}
                    </div>
                  </div>
        </Col>
      </Row>
    </>
  );

  return (
    <>
      <Link className="btn btn-light my-3" to="/">
        Go Back
      </Link>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">
          {error?.data?.message || error.error}
        </Message>
      ) : (
        renderNoteDetails()
      )}
    </>
  );
};

export default NoteScreen;